window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.customMedia = {
    '--xs': '(max-width: 575.98px)',
    '--sm': '(max-width: 767.98px)',
    '--md': '(max-width: 991.98px)',
    '--lg': '(max-width: 1199.98px)',
};

